var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("v-img", {
    staticClass: "d-inline-block",
    attrs: {
      height: _vm.height,
      "max-width": _vm.maxWidth,
      src: _vm.icons[_vm.icon],
      contain: ""
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }